import application from 'application/application';

const controller = 'PdfSvgController';

application.controller(controller, [
	'$scope',
	function($scope) {
		$scope.size = $scope.size && $scope.size > 0 ? $scope.size : '32';
	}
]);

export default controller;
